import Stimulus from '@root/javascripts/stimulus';

import SocialMediaUrlsController from '../components/social_media_urls_controller';
import FiscalInfoController from '../components/fiscal_info_controller';
import IncomeController from '../components/income_controller';

Stimulus.register('social-media-urls', SocialMediaUrlsController);
Stimulus.register('fiscal-info', FiscalInfoController);
Stimulus.register('income', IncomeController);

$.ajaxSetup({
  statusCode: {
    302(response) {
      const redirectUrl = response.getResponseHeader('X-Ajax-Redirect-Url');
      if (redirectUrl !== undefined) {
        window.location.pathname = redirectUrl;
      }
    },
  },
});
